// Copyright (c) Bentley Systems
export class ElistFilter {
  public id: string;
  public value: any;

  constructor(filterId: string, filterValue: any) {
    this.id = filterId;
    this.value = filterValue;
  }
}
